import {
  Box,
  Card,
  Text,
  Heading,
  CardBody,
  CardHeader,
  TrackScrolledIntoView
} from '@homebotapp/hb-react-component-catalog'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../types/rootState'
import { defineMessages, useIntl } from 'react-intl'
import { PmiEstimatedModuleDmStep } from './PmiEstimatedModuleDmStep'
import { PmiEstimatedModuleInputStep } from './PmiEstimatedModuleInputStep'
import { PmiEstimatedModuleInitialStep } from './PmiEstimatedModuleInitialStep'
import { PmiEstimatedModuleMortgagesStep } from './PmiEstimatedModuleMortgagesStep'
import { HOMEOWNER_DIGEST_PMI_MODULE } from '../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MSG = defineMessages({
  tuneHomebot: {
    id: 'Pmi.Estimated.tuneYourHomebot',
    defaultMessage: 'Tune your homebot'
  },
  doYouHavePmi: {
    id: 'Pmi.Estimated.doYouHavePmi',
    defaultMessage: 'Do you have PMI?'
  },
  estimating: {
    id: 'Pmi.Estimated.bodyText',
    defaultMessage: 'We estimate that you might have private mortgage insurance (PMI).'
  }
})

export enum PmiStepEnum {
  DmStep = 'DmStep',
  InitialStep = 'InitialStep',
  InputStep = 'InputStep',
  MortgageStep = 'MortgageStep'
}

export const PmiEstimatedModule = () => {
  const intl = useIntl()
  const [inProgress, setInProgress] = useState(false)
  const [step, setStep] = useState(PmiStepEnum.InitialStep)
  const showPmiEstimatedModule = useSelector<RootState, boolean | null>(state => state.pmi.showPmiEstimatedModule)

  if (!showPmiEstimatedModule && !inProgress) return null

  return (
    <TrackScrolledIntoView
      tracking={{
        guid: '4g4punjB5G3fk7SdNzMHex',
        ui_context: HOMEOWNER_DIGEST_PMI_MODULE,
        descriptor: 'PMI Estimated Module'
      }}
    >
      <Card size='lg' data-qa='pmi-estimated-module'>
        <CardHeader paddingBottom={0}>
          <Heading as='h3' size='xs' color='brand' textAlign='left' variant='eyebrow'>
            {intl.formatMessage(MSG.tuneHomebot)}
          </Heading>
          <Heading as='h2' marginBottom={0} textAlign='left'>
            {intl.formatMessage(MSG.doYouHavePmi)}
          </Heading>
        </CardHeader>
        <CardBody>
          <Text>{intl.formatMessage(MSG.estimating)}</Text>
          <Box marginTop={8}>
            {step === PmiStepEnum.DmStep && <PmiEstimatedModuleDmStep setStep={setStep} />}
            {step === PmiStepEnum.MortgageStep && <PmiEstimatedModuleMortgagesStep setInProgress={setInProgress} />}
            {step === PmiStepEnum.InputStep && (
              <PmiEstimatedModuleInputStep setStep={setStep} setInProgress={setInProgress} />
            )}
            {step === PmiStepEnum.InitialStep && (
              <PmiEstimatedModuleInitialStep setStep={setStep} setInProgress={setInProgress} />
            )}
          </Box>
        </CardBody>
      </Card>
    </TrackScrolledIntoView>
  )
}
